import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FiArrowLeft, FiEye, FiUsers } from "react-icons/fi";
import api from "@/services/api";
import Loader from "@/components/loader";

export default function PostDetail() {
  const { postId } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const res = await api.get(`/post/${postId}`);
        if (res.ok) setPost(res.data);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [postId]);

  if (loading) return <div className="flex justify-center py-20"><Loader /></div>;
  if (!post) return <div className="text-center py-20 text-gray-500">Post not found</div>;

  return (
    <div className="max-w-4xl mx-auto">
      <button onClick={() => navigate("..")} className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition-colors">
        <FiArrowLeft className="w-4 h-4" />
        <span className="text-sm font-medium">Back to channels</span>
      </button>

      {/* Header */}
      <div className="bg-white border border-gray-200 rounded-xl p-6 mb-6">
        <div className="flex items-center gap-4 mb-4">
          {post.channel_logo ? (
            <img src={post.channel_logo} alt={post.channel_name} className="w-12 h-12 rounded-lg object-contain border border-gray-200" />
          ) : (
            <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center">
              <span className="text-lg font-bold text-gray-400">{post.channel_name?.[0]}</span>
            </div>
          )}
          <div>
            <h1 className="text-xl font-bold text-gray-900">{post.channel_name}</h1>
            <div className="flex items-center gap-3 mt-1">
              {post.status === "active" ? (
                <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium bg-green-50 text-green-700">
                  <span className="w-1.5 h-1.5 rounded-full bg-green-500" /> Active
                </span>
              ) : (
                <span className="inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-xs font-medium bg-gray-50 text-gray-500">
                  <span className="w-1.5 h-1.5 rounded-full bg-gray-400" /> {post.status}
                </span>
              )}
              <span className="text-xs text-gray-400">{post._id}</span>
            </div>
          </div>
        </div>

        {/* Quick stats */}
        <div className="flex gap-6 text-sm text-gray-600">
          <div className="flex items-center gap-1.5">
            <FiEye className="w-4 h-4 text-gray-400" />
            <span>{post.viewed_count || 0} views</span>
          </div>
          {post.created_at && (
            <div className="text-gray-400">
              Created {new Date(post.created_at).toLocaleDateString()}
            </div>
          )}
        </div>
      </div>

      {/* Raw JSON */}
      <div className="bg-white border border-gray-200 rounded-xl p-6">
        <h2 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-3">Raw Data</h2>
        <pre className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-xs text-gray-700 overflow-auto max-h-[600px]">
          {JSON.stringify(post, null, 2)}
        </pre>
      </div>
    </div>
  );
}
